const nonSortableOptions = ['extraMultipliers', 'reviewCycles', 'countries'];

export default nonSortableOptions;
